import React from 'react'
import { useNavigate } from 'react-router-dom'
import verification from "../assets/verification.png"

function Verification() {
const navigate=useNavigate()
const sendData=()=>{
navigate("/code")
}


    return (<>
        <div className='d-flex align-items-center ps-3 pe-3' style={{height:"100vh"}}>
            <div className='container box_div pb-5  d-flex justify-content-center' style={{ position: "relative" }}>
                <div>
                    <div className='verification_card pt-4'>
                        <div className='d-flex  justify-content-center'>
                            <img src={verification} />
                        </div>
                        <p className='otp_heading'>OTP Verification</p>
                        <p className='otp_text'>Select a method for OTP Verification</p>
                        <div className='d-flex  justify-content-center RADIO_VERIFICATION' style={{ width: '100%' }}>
                            <div>
                                <div className='d-flex gap-1 align-items-center '>
                                    <input type="radio" />
                                    <p className='radio_verify'>Verification via E-mail</p>
                                </div>
                                <div className='d-flex gap-1 align-items-center '>
                                    <input type="radio" />
                                    <p className='radio_verify' >Phone text message via SMS</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='code_btn'>
                        <button className='next_btn mb-4' onClick={sendData} style={{ marginBottom: "0px" }}>Send Code</button>
                    </div>
                    <div className='bac_div bac2_div'>
                        <p className='back_text'>Back</p>
                    </div>
                </div>
            </div>
        </div>
    </>

    )
}

export default Verification